import { id } from 'date-fns/locale';
import { getSliderItems } from './componenets/PracticeAssignment';
import PracticeReviews from './componenets/PracticeReviews';

const practices = [
  {
    name: 'practice1-1',
    value: '"Read a story to your child every night before bed."',
  },
  {
    name: 'top-5',
    value: '["2","2","2"]',
  },
  {
    name: 'practice2-2',
    value: '["Going to bed on time","Staying in bed all night"]',
  },
  {
    name: 'ds-practice-1',
    value: '["Be respectful"]',
  },
  {
    name: 'ignore-TYN-1a',
    value: '["Jumping up and down on furniture"]',
  },
  {
    name: 'mod-5-pr-1',
    value: '"Chair"',
  },
  {
    name: 'practice-to1',
    value: '"hi"',
  },
  {
    name: 'p-practice-2',
    value:
      '["Money worries","Not being able to spend QUALITY time with the kids"]',
  },
  {
    name: 'mod-6-pr-1',
    value: '"truth"',
  },
];

const practiceReviews = [
  {
    date: '2023-01-04T11:52:40.193',
    module: 6,
    name: '6',
    value: '{"practiceRev6-1":"YES"}',
  },
  {
    date: '2023-01-06T11:59:49.993',
    module: 1,
    name: '1',
    value:
      '{"practiceRev1-1":"YES","practiceRev1-2":"Almost every day","practiceRev1-3":"Played the child’s choice of games","practiceRev1-4":"YES","practiceRev1-5":"YES"}',
  },
  {
    date: '2023-01-18T09:58:55.053',
    module: 2,
    name: '2',
    value: '{"practiceRev2-1":"YES"}',
  },
  {
    date: '2023-01-18T09:59:02.983',
    module: 3,
    name: '3',
    value: '{"practiceRev3-1":"YES"}',
  },
];

const returnPracticeData = (modNumber) => {
  return {
    completed: true,
    items: [
      {
        name: '',
        info: {
          type: 'practice',
          module,
          component: getSliderItems(
            practices,
            '',
            modNumber,
            '2022-12-09T13:09:18.7652433'
          ).module,
        },
        completedDate: undefined,
      },
    ],
  };
};

console.log('returnPracticeData', returnPracticeData(1));

export const ezpModules = [
  {
    module: 1,
    title: 'Child-Centered Time, Routines, & Traditions',
    subModules: [
      {
        title: 'Child Centered Time',
        items: [
          {
            name: 'Knowledge Check',
            info: {
              type: 'check',
              id: 11,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
        ],
      },
      {
        title: 'Teaching Through Play and Descriptive Commenting',
        items: [
          {
            name: 'Knowledge Check',
            info: {
              type: 'check',
              id: 12,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
        ],
      },
      {
        title: 'Family Routines and Traditions',
        items: [
          {
            name: 'Activity | Rockin Routines',
            info: {
              type: 'badge',
              id: 13,
            },
            completedDate: undefined,
          },
        ],
      },
      {
        title: 'Reading as Routine',
        items: [
          {
            name: 'Knowledge Check',
            info: {
              type: 'check',
              id: 14,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
          {
            name: 'Selected Routine',
            info: {
              type: 'practice1-1',
              id: 15,
            },
            completedDate: undefined,
          },
        ],
      },
      {
        title: 'Wrap Up',
        items: [
          {
            name: 'Completion Badge',
            info: {
              type: 'badge',
              id: 16,
            },
            completedDate: undefined,
          },
          {
            name: 'Survey Rating',
            info: {
              type: 'survey',
              id: 17,
            },
            completedDate: undefined,
          },
        ],
      },
      {
        title: 'Practice Assignment',
        id: 18,
        ...returnPracticeData(1),
      },
      {
        title: 'Practice Review',
        id: 19,
        completed: true,
        items: [
          {
            name: '',
            info: {
              type: 'practice',
              module: practiceReviews.find((item) => item.module === 1),
              component: (
                <PracticeReviews
                  practiceReviewArray={practiceReviews}
                  practiceItems={practices}
                  mod={1}
                />
              ),
            },
            completedDate: undefined,
          },
        ],
      },
    ],
  },
  {
    module: 2,
    title: 'Using Praise, Encouragement, and Rewards',
    subModules: [
      {
        title: 'Labeled Praise',
        items: [
          {
            name: 'Activity: How Do You Want Your Child to Feel?',
            info: {
              type: 'badge',
              id: 21,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
          {
            name: 'Knowledge Check',
            info: {
              type: 'check',
              id: 22,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
          {
            name: 'Activity: Labeled Versus Unlabeled Praise',
            info: {
              type: 'badge',
              id: 23,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
        ],
      },
      {
        title: 'If You Want To See a Behavior Again, Give It Your Attention!',
        items: [
          {
            name: 'Knowledge Check',
            info: {
              type: 'check',
              id: 24,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
          {
            name: 'Knowledge Check',
            info: {
              type: 'check',
              id: 25,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
          //add practice here
        ],
      },
      {
        title: 'Using Rewards for Challenging Behaviors',
        items: [
          {
            name: 'Activity: Reward Program',
            info: {
              type: 'badge',
              id: 26,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
          {
            name: 'Knowledge Check',
            info: {
              type: 'check',
              id: 27,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
        ],
      },
      {
        title: 'Using Rewards, Not Bribes!',
        items: [
          {
            name: 'Knowledge Check',
            info: {
              type: 'check',
              id: 28,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
          {
            name: 'Knowledge Check',
            info: {
              type: 'check',
              id: 29,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
        ],
      },
      {
        title: 'Wrap Up',
        items: [
          {
            name: 'Completion Badge',
            info: {
              type: 'badge',
              id: 210,
            },
            completedDate: undefined,
          },
          {
            name: 'Survey Rating',
            info: {
              type: 'survey',
              id: 211,
            },
            completedDate: undefined,
          },
        ],
      },
      {
        title: 'Practice Assignment',
        id: 212,
        ...returnPracticeData(2),
      },
      {
        title: 'Practice Review',
        id: 213,
        completed: true,
        items: [
          {
            name: '',
            info: {
              type: 'practice',
              module: practiceReviews.find((item) => item.module === 2),
              component: (
                <PracticeReviews
                  practiceReviewArray={practiceReviews}
                  practiceItems={practices}
                  mod={2}
                />
              ),
            },
            completedDate: undefined,
          },
        ],
      },
    ],
  },
  {
    module: 3,
    title: 'Do Statements',
    subModules: [
      {
        title: 'DO Statements',
        items: [
          {
            name: 'Knowledge Check',
            info: {
              type: 'check',
              id: 31,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
          {
            name: 'Knowledge Check',
            info: {
              type: 'check',
              id: 32,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
          {
            name: 'Knowledge Check',
            info: {
              type: 'check',
              id: 33,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
          {
            name: 'Activity - DO Statements',
            info: {
              type: 'badge',
              id: 34,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
        ],
      },
      {
        title: 'Following Through on Expectations',
        items: [
          {
            name: 'Knowledge Check',
            info: {
              type: 'check',
              id: 35,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
        ],
      },
      {
        title: 'Warning Statements',
        items: [
          {
            name: 'Knowledge Check',
            info: {
              type: 'check',
              id: 36,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
        ],
      },
      {
        title: 'Wrap Up',
        items: [
          {
            name: 'Completion Badge',
            info: {
              type: 'badge',
              id: 37,
            },
            completedDate: undefined,
          },
          {
            name: 'Survey Rating',
            info: {
              type: 'survey',
              id: 38,
            },
            completedDate: undefined,
          },
        ],
      },
      {
        title: 'Practice Assignment',
        id: 39,
        ...returnPracticeData(3),
      },
      {
        title: 'Practice Review',
        completed: true,
        items: [
          {
            name: '',
            id: 310,
            info: {
              type: 'practice',
              module: practiceReviews.find((item) => item.module === 3),
              component: (
                <PracticeReviews
                  practiceReviewArray={practiceReviews}
                  practiceItems={practices}
                  mod={3}
                />
              ),
            },
            completedDate: undefined,
          },
        ],
      },
    ],
  },
  {
    module: 4,
    engagement: {
      score: 8,
      total: 10,
    },
    title: 'Setting Limits and Managing Behavior',
    subModules: [
      {
        title: 'Natural If/Then Statements',
        items: [
          {
            name: 'Activity - Natural If/Then Statements',
            info: {
              type: 'badge',
              id: 41,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
          {
            name: 'Knowledge Check',
            info: {
              type: 'check',
              id: 42,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
        ],
      },
      {
        title: 'Logical If/Then Statements',
        items: [
          {
            name: 'Activity: Logical If/Then Statements',
            info: {
              type: 'badge',
              id: 43,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
          {
            name: 'Knowledge Check',
            info: {
              type: 'check',
              id: 44,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
        ],
      },
      {
        title: 'When/Then Statements',
        items: [
          {
            name: 'Activity: When/Then Statements',
            info: {
              type: 'badge',
              id: 45,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
          {
            name: 'Knowledge Check',
            info: {
              type: 'check',
              id: 46,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
        ],
      },
      {
        title: 'Ignore',
        items: [
          {
            name: 'Activity: What Behavior Can YOU Ignore?',
            info: {
              type: 'badge',
              id: 47,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
          {
            name: 'Knowledge Check',
            info: {
              type: 'check',
              id: 48,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
          {
            name: 'Knowledge Check',
            info: {
              type: 'check',
              id: 49,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
        ],
      },
      {
        title: 'Distract',
        items: [
          {
            name: 'Knowledge Check',
            info: {
              type: 'check',
              id: 410,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
          {
            name: 'Knowledge Check',
            info: {
              type: 'check',
              id: 411,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
        ],
      },
      {
        title: 'Wrap Up',
        items: [
          {
            name: 'Completion Badge',
            info: {
              type: 'badge',
              id: 412,
            },
            completedDate: undefined,
          },
          {
            name: 'Survey Rating',
            info: {
              type: 'survey',
              id: 413,
            },
            completedDate: undefined,
          },
        ],
      },
      {
        title: 'Practice Assignment',
        ...returnPracticeData(4),
        id: 414,
      },
      {
        title: 'Practice Review',
        id: 415,
        completed: true,
        items: [
          {
            name: '',
            info: {
              type: 'practice',
              module: practiceReviews.find((item) => item.module === 4),
              component: (
                <PracticeReviews
                  practiceReviewArray={practiceReviews}
                  practiceItems={practices}
                  mod={4}
                />
              ),
            },
            completedDate: undefined,
          },
        ],
      },
    ],
  },
  {
    module: 5,
    engagement: {
      score: 2,
      total: 12,
    },
    title: 'Effective Discipline and Time-Outs',
    subModules: [
      {
        title: 'Using Time-Out: Step 2',
        items: [
          {
            name: 'Knowledge Check',
            info: {
              type: 'check',
              id: 51,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
          {
            name: 'Knowledge Check',
            info: {
              type: 'check',
              id: 52,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
          {
            name: 'Knowledge Check',
            info: {
              type: 'check',
              id: 53,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
        ],
      },
      {
        title: 'Using Time-Out: Step 3',
        items: [
          {
            name: 'Knowledge Check',
            info: {
              type: 'check',
              id: 54,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
          {
            name: 'Activity: Common Concerns About Using Time-Out',
            info: {
              type: 'badge',
              id: 55,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
        ],
      },
      {
        title: 'Time-Out in a Public Place',
        items: [
          {
            name: 'Activity: Time-Outs in Public',
            info: {
              type: 'badge',
              id: 56,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
        ],
      },
      {
        title: 'Wrap Up',
        items: [
          {
            name: 'Completion Badge',
            info: {
              type: 'badge',
              id: 57,
            },
            completedDate: undefined,
          },
          {
            name: 'Survey Rating',
            info: {
              type: 'survey',
              id: 58,
            },
            completedDate: undefined,
          },
        ],
      },
      {
        title: 'Practice Assignment',
        id: 59,
        ...returnPracticeData(5),
      },
      {
        title: 'Practice Review',
        id: 510,
        completed: true,
        items: [
          {
            name: '',
            info: {
              type: 'practice',
              module: practiceReviews.find((item) => item.module === 5),
              component: '❌',
            },
            completedDate: undefined,
          },
        ],
      },
    ],
  },
  {
    module: 6,
    engagement: {
      score: 2,
      total: 15,
    },
    title: 'Reducing Stress and Problem Solving',
    subModules: [
      {
        title: 'Parenting Stress',
        items: [
          {
            name: 'Activity: What Causes You Stress As A Parent?',
            info: {
              type: 'badge',
              id: 61,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
          {
            name: 'Knowledge Check',
            info: {
              type: 'check',
              id: 62,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
        ],
      },
      {
        title: 'Reducing Stress',
        items: [
          {
            name: 'Activity : Reframing',
            info: {
              type: 'badge',
              id: 63,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
          {
            name: 'Knowledge Check',
            info: {
              type: 'check',
              id: 64,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
        ],
      },
      {
        title: 'Problem Solving',
        items: [
          {
            name: 'Activity: "You" vs "I" Statements',
            info: {
              type: 'badge',
              id: 65,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
          {
            name: 'Knowledge Check',
            info: {
              type: 'check',
              id: 66,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
          {
            name: 'Knowledge Check',
            info: {
              type: 'check',
              id: 67,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
          {
            name: 'Knowledge Check',
            info: {
              type: 'check',
              id: 68,
            },
            completedDate: '2022-12-09T13:09:18.7652433',
          },
        ],
      },
      {
        title: 'Wrap Up',
        items: [
          {
            name: 'Completion Badge',
            info: {
              type: 'badge',
              id: 69,
            },
            completedDate: undefined,
          },
          {
            name: 'Survey Rating',
            info: {
              type: 'survey',
              id: 610,
            },
            completedDate: undefined,
          },
        ],
      },
      {
        title: 'Practice Assignment',
        id: 611,
        ...returnPracticeData(6),
      },
      {
        title: 'Practice Review',
        id: 612,
        completed: true,
        items: [
          {
            name: '',
            info: {
              type: 'practice',
              module: practiceReviews.find((item) => item.module === 6),
              component: '❌',
            },
            completedDate: undefined,
          },
        ],
      },
    ],
  },
];

export const mockD = {
  mod1: [
    { completed: '2022-12-09T13:09:18.7652433', id: 11 },
    { completed: '2022-12-09T13:09:18.7652433', id: 12 },
    { completed: false, id: 13 },
    { completed: '2022-12-09T13:09:18.7652433', id: 14 },
    { completed: false, id: 15 },
    { completed: false, id: 16 },
    { completed: false, id: 17 },
    { completed: false, id: 18 },
    { completed: false, id: 19 },
  ],
  mod2: [
    { completed: '2022-12-09T13:09:18.7652433', id: 21 },
    { completed: '2022-12-09T13:09:18.7652433', id: 22 },
    { completed: '2022-12-09T13:09:18.7652433', id: 23 },
    { completed: '2022-12-09T13:09:18.7652433', id: 24 },
    { completed: '2022-12-09T13:09:18.7652433', id: 25 },
    { completed: '2022-12-09T13:09:18.7652433', id: 26 },
    { completed: '2022-12-09T13:09:18.7652433', id: 27 },
    { completed: '2022-12-09T13:09:18.7652433', id: 28 },
    { completed: '2022-12-09T13:09:18.7652433', id: 29 },
    { completed: false, id: 210 },
    { completed: false, id: 211 },
    { completed: false, id: 212 },
    { completed: false, id: 213 },
  ],
  mod3: [
    { completed: '2022-12-09T13:09:18.7652433', id: 31 },
    { completed: '2022-12-09T13:09:18.7652433', id: 32 },
    { completed: '2022-12-09T13:09:18.7652433', id: 33 },
    { completed: '2022-12-09T13:09:18.7652433', id: 34 },
    { completed: '2022-12-09T13:09:18.7652433', id: 35 },
    { completed: '2022-12-09T13:09:18.7652433', id: 36 },
    { completed: false, id: 37 },
    { completed: false, id: 38 },
    { completed: false, id: 39 },
    { completed: false, id: 310 },
  ],
  mod4: [
    { completed: '2022-12-09T13:09:18.7652433', id: 41 },
    { completed: '2022-12-09T13:09:18.7652433', id: 42 },
    { completed: '2022-12-09T13:09:18.7652433', id: 43 },
    { completed: '2022-12-09T13:09:18.7652433', id: 44 },
    { completed: '2022-12-09T13:09:18.7652433', id: 45 },
    { completed: '2022-12-09T13:09:18.7652433', id: 46 },
    { completed: '2022-12-09T13:09:18.7652433', id: 47 },
    { completed: '2022-12-09T13:09:18.7652433', id: 48 },
    { completed: '2022-12-09T13:09:18.7652433', id: 49 },
    { completed: '2022-12-09T13:09:18.7652433', id: 410 },
    { completed: '2022-12-09T13:09:18.7652433', id: 411 },
    { completed: false, id: 412 },
    { completed: false, id: 413 },
    { completed: false, id: 414 },
    { completed: false, id: 415 },
  ],
  mod5: [
    { completed: '2022-12-09T13:09:18.7652433', id: 51 },
    { completed: '2022-12-09T13:09:18.7652433', id: 52 },
    { completed: '2022-12-09T13:09:18.7652433', id: 53 },
    { completed: '2022-12-09T13:09:18.7652433', id: 54 },
    { completed: '2022-12-09T13:09:18.7652433', id: 55 },
    { completed: '2022-12-09T13:09:18.7652433', id: 56 },
    { completed: false, id: 57 },
    { completed: false, id: 58 },
    { completed: false, id: 59 },
    { completed: false, id: 510 },
  ],
  mod6: [
    { completed: '2022-12-09T13:09:18.7652433', id: 61 },
    { completed: '2022-12-09T13:09:18.7652433', id: 62 },
    { completed: '2022-12-09T13:09:18.7652433', id: 63 },
    { completed: '2022-12-09T13:09:18.7652433', id: 64 },
    { completed: '2022-12-09T13:09:18.7652433', id: 65 },
    { completed: '2022-12-09T13:09:18.7652433', id: 66 },
    { completed: '2022-12-09T13:09:18.7652433', id: 67 },
    { completed: '2022-12-09T13:09:18.7652433', id: 68 },
    { completed: false, id: 69 },
    { completed: false, id: 610 },
    { completed: false, id: 611 },
    { completed: false, id: 612 },
  ],
};

export function getEngagementScores(modules) {
  const scores = [];

  for (const [modKey, items] of Object.entries(modules)) {
    const moduleNum = Number(modKey); // Safer and clearer than parseInt
    const total = items.length;
    const completed = items.filter(
      (item) => item.completed !== false && item.completed !== undefined
    ).length;
    const percentage = total > 0 ? Math.round((completed / total) * 100) : 0;

    scores.push({
      module: isNaN(moduleNum) ? modKey : moduleNum,
      engagementScore: percentage,
    });
  }

  console.log('engagementScores', scores);
  return scores;
}

export const engagementScores = getEngagementScores(mockD);
